import styled from "styled-components";

const WSBottomContainer = styled.div`
  display: flex;
  flex: 1;
  align-items: flex-end;
  margin-bottom: 30px;
`;
export default WSBottomContainer;
